import React from "react";
import { RaisedButton, Checkbox, TextField, IconButton } from "material-ui";
import { colors } from "material-ui/styles";
import copy from "copy-to-clipboard";
import { Link } from "react-router";

import InfoNotice from "./info-notice.jsx";
import PercentField from "./percent-field.jsx";
import Label from "./label.jsx";

import DeleteIcon from "material-ui/svg-icons/action/delete";
import CopyIcon from "material-ui/svg-icons/content/content-copy";

import UserStore from "../../stores/UserStore";

class RevenuSharingEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { revenueShare } = this.props;

    const enabled = !!revenueShare;
    const allReady =
      revenueShare && revenueShare.recipients.every(r => !!r.user);

    const primaryPercent = revenueShare
      ? 1 - revenueShare.recipients.reduce((t, r) => t + (r.percent || 0), 0)
      : 0;
    const primaryDonationPercent = revenueShare
      ? 1 -
        revenueShare.recipients.reduce(
          (t, r) => t + (r.donation_percent || 0),
          0
        )
      : 0;

    const hasNotEnabledRevenueSharing = !(UserStore.getUser() || {})
      .revenue_sharing_available;

    return (
      <div>
        <p>
          Use Eventive Revenue Sharing to automatically share the proceeds from
          this screening with one or more additional parties.
          <br />
          <strong>
            Ensure your settings are correct, as modifications will NOT apply
            retroactively.
          </strong>
          <InfoNotice style={{ marginTop: 5 }}>
            Check out our{" "}
            <a
              href="https://help.eventive.org/en/articles/5043252-eventive-revenue-sharing"
              target="_blank"
            >
              guide to Eventive Revenue Sharing
            </a>
            .
          </InfoNotice>
        </p>
        <div>
          <div>
            <Checkbox
              label={"Enable Revenue Sharing for this screening"}
              style={{ display: "inline-block", width: 350 }}
              checked={!hasNotEnabledRevenueSharing && enabled}
              disabled={hasNotEnabledRevenueSharing}
              onCheck={() => {
                if (
                  enabled &&
                  !window.confirm(
                    `Are you sure? All revenue sharing will be disabled for this screening and will require a new invitation to reconfigure.`
                  )
                ) {
                  return;
                }

                this.props.onChange(enabled ? null : { recipients: [{}] });
              }}
            />
          </div>

          {hasNotEnabledRevenueSharing ? (
            <div style={{ marginTop: 5 }}>
              You must first{" "}
              <Link to="/revenue_sharing">
                connect Eventive Revenue Sharing
              </Link>{" "}
              in order to use this feature.
            </div>
          ) : revenueShare ? (
            <div>
              <div>
                <Checkbox
                  label={
                    "Allow recipients to view event attendees, sales, and analytics"
                  }
                  style={{ display: "inline-block", width: 500 }}
                  checked={revenueShare.allow_recipients_to_view_event_data}
                  onCheck={() => {
                    this.props.onChange({
                      ...revenueShare,
                      allow_recipients_to_view_event_data:
                        !revenueShare.allow_recipients_to_view_event_data
                    });
                  }}
                />
              </div>

              {!allReady ? (
                <div
                  style={{
                    marginTop: 10,
                    marginBottom: 5,
                    display: "inline-block",
                    border: `1px solid ${colors.yellow900}`,
                    padding: "4px 10px",
                    color: colors.yellow900,
                    backgroundColor: colors.yellow50,
                    borderRadius: 10,
                    maxWidth: 650
                  }}
                >
                  <strong>Heads up!</strong> Until every recipient has accepted
                  their revenue sharing invitation, tickets to this event will
                  not be available for sale. Invitations are sent from
                  "noreply@eventive.org".
                </div>
              ) : null}

              <div>
                <TextField
                  floatingLabelText="Primary revenue recipient (you)"
                  floatingLabelFixed={true}
                  value={`${UserStore.getUser().organization}`}
                  disabled
                />
                <PercentField
                  style={{ marginLeft: 20, width: 150 }}
                  floatingLabelText="Net sales percent"
                  floatingLabelFixed={true}
                  disabled
                  value={primaryPercent}
                />
                <PercentField
                  style={{ marginLeft: 20, width: 150 }}
                  floatingLabelText="Donations percent"
                  floatingLabelFixed={true}
                  disabled
                  value={primaryDonationPercent}
                />
              </div>

              {revenueShare.recipients.map((recipient, i) => {
                const acceptedUser = recipient.user;
                const inviteSent = !!recipient.invite_token;

                return (
                  <div key={i}>
                    <div>
                      <span style={{ position: "relative" }}>
                        <TextField
                          floatingLabelText={
                            acceptedUser ? (
                              "Revenue share recipient"
                            ) : inviteSent ? (
                              <span>
                                Invited recipient{" "}
                                <span
                                  style={{
                                    backgroundColor: colors.yellow100,
                                    padding: "2px 5px",
                                    borderRadius: 5,
                                    fontWeight: "bold",
                                    color: colors.yellow900,
                                    fontSize: 14,
                                    verticalAlign: 0
                                  }}
                                >
                                  Not yet accepted
                                </span>
                              </span>
                            ) : (
                              "Recipient email address to invite"
                            )
                          }
                          floatingLabelFixed={true}
                          value={
                            acceptedUser
                              ? acceptedUser.organization
                              : recipient.invite_email
                          }
                          disabled={acceptedUser || inviteSent}
                          onChange={e => {
                            revenueShare.recipients[i].invite_email =
                              e.target.value;
                            this.props.onChange(revenueShare);
                          }}
                          autoFocus
                        />
                      </span>
                      <PercentField
                        style={{ marginLeft: 20, width: 150 }}
                        floatingLabelText="Net sales percent"
                        floatingLabelFixed={true}
                        placeholder="0%"
                        value={recipient.percent}
                        onChange={e => {
                          revenueShare.recipients[i].percent = e.target.value;
                          this.props.onChange(revenueShare);
                        }}
                      />
                      <PercentField
                        style={{ marginLeft: 20, width: 150 }}
                        floatingLabelText="Donations percent"
                        floatingLabelFixed={true}
                        placeholder="0%"
                        value={recipient.donation_percent}
                        onChange={e => {
                          revenueShare.recipients[i].donation_percent =
                            e.target.value;
                          this.props.onChange(revenueShare);
                        }}
                      />
                      {revenueShare.recipients.length > 1 ? (
                        <IconButton
                          tooltip="Remove"
                          style={{ marginLeft: 10 }}
                          onClick={() => {
                            if (
                              (recipient.invite_token || recipient.user) &&
                              !window.confirm(
                                `Are you sure you would like to remove "${
                                  recipient.user
                                    ? recipient.user.organization
                                    : recipient.invite_email
                                }"? The recipient will receive an email notification and will no longer receive revenue sharing from this event.`
                              )
                            ) {
                              return;
                            }

                            revenueShare.recipients.splice(i, 1);
                            this.props.onChange(revenueShare);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      ) : null}
                      {recipient.invite_token ? (
                        <IconButton
                          tooltip="Copy invite link"
                          style={{ marginLeft: 10 }}
                          onClick={() => {
                            copy(
                              `${window.location.protocol}//${window.location.host}/accept_revenue_sharing_invite?token=${recipient.invite_token}`
                            );
                          }}
                        >
                          <CopyIcon />
                        </IconButton>
                      ) : null}
                      {!recipient.invite_token && !recipient.user ? (
                        <div
                          style={{
                            display: "inline-block",
                            marginLeft:
                              revenueShare.recipients.length > 1 ? 10 : 20,
                            width: 140,
                            fontSize: "0.8em",
                            lineHeight: "0.9em",
                            color: "rgba(33, 33, 33, 0.5)",
                            fontStyle: "italic"
                          }}
                        >
                          Invite will be sent after you click "Save changes"
                          above.
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              })}

              <div style={{ marginTop: 20 }}>
                <RaisedButton
                  label="Add another recipient"
                  onTouchTap={() => {
                    revenueShare.recipients.push({});
                    this.props.onChange(revenueShare);
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default RevenuSharingEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/revenue-sharing-editor.jsx